import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

import { TableName } from '@models/column';
import { Unset } from '@utils';

import { InlineEditor, InlineEditorProps, Widget } from './_InlineDraftEditor';

export const TableWidget = (
  props: {
    tables: TableName[];
  } & Widget<TableName | Unset, TableName>
) => {
  return (
    <Autocomplete
      style={{ width: '180px' }}
      options={props.tables}
      value={props.value ?? null}
      size="small"
      autoComplete
      blurOnSelect
      onBlur={props.onBlur}
      onChange={(e, value) => value && props.onValueChange(value)}
      renderInput={params => (
        <TextField {...params} variant="standard" placeholder="Table" />
      )}
    />
  );
};

export const TableInlineEditor = (
  props: InlineEditorProps<string> & { tables: TableName[] }
) => {
  return (
    <InlineEditor
      {...props}
      widget={TableWidget}
      widgetProps={{ tables: props.tables }}
    />
  );
};
